module.exports = __webpack_public_path__ + "img/untitled.496.d35177d6.png";